export default __webpack_public_path__ + "static/media/logo-collapsed.eee19a40.png";